import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesService } from '@/apiConnection/roles.service';
import { AddButtonComponent } from '@/components/add-button/add-button.component';
import { CustomDeleteComponent } from '@/components/custom-delete/custom-delete.component';
import { SAUModalService } from '@some-angular-utils/modal';
import { RoleFormComponent } from '../role-form/role-form.component';
import { RolePanelsComponent } from '../role-panels/role-panels.component';
import { Urls } from '@/apiConnection/urls';
import { Utils } from '@/utils/utils';

@Component({
  imports: [
    CommonModule,
    AddButtonComponent,
  ],
  templateUrl: './roles-list.page.html',
})
export class RolesListPage implements OnInit {
  loading = false;
  roles: any[] = [];

  private sauModalService = inject(SAUModalService);

  rolesUrl = Urls.urls.roles;

  constructor(private rolesService: RolesService, private cdr: ChangeDetectorRef) {}

  ngOnInit() {
    this.loadRoles();
  }

  loadRoles() {
    this.loading = true;
    this.rolesService.getMyRoles().subscribe({
      next: (res: any) => {this.loading = false;this.roles = res.roles ?? []; this.cdr.detectChanges()},
      error: (error: any) => Utils.notification.alert(Utils.extractErrorMessage(error) || 'Error al cargar los roles'),
    });
  }

  openCreate() {
    const modalRef = this.sauModalService.open(RoleFormComponent, {});
    modalRef.componentInstance.id = 0;
    modalRef.componentInstance.role = null;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.loadRoles();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openEdit(role: any) {
    const modalRef = this.sauModalService.open(RoleFormComponent, {});
    modalRef.componentInstance.id = role.id;
    modalRef.componentInstance.role = role;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.loadRoles();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openDelete(role: any) {
    const modalRef = this.sauModalService.open(CustomDeleteComponent, {});
    modalRef.componentInstance.id = role.id;
    modalRef.componentInstance.url = this.rolesUrl;
    modalRef.componentInstance.item = 'rol';

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.loadRoles();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }

  openPanels(role: any) {
    const modalRef = this.sauModalService.open(RolePanelsComponent, {});
    modalRef.componentInstance.roleId = role.id;
    modalRef.componentInstance.roleName = role.name;

    modalRef.componentInstance.acceptFunction.subscribe(() => {
      this.loadRoles();
    });

    modalRef.componentInstance.closeFunction.subscribe(() => {
      modalRef.dismiss();
    });
  }
}
